import i18n from '../locales/i18n';

const { t } = i18n;

export const COPIED_TO_CLIPBOARD = t('copiedToClipboard');
export const REGISTERED_SHARED_LIBRARY = t('registeredInSharedLibrary');
export const STUDENT_REGISTRATION_SUCCESS = t('registeredAsStudent');
